/** Pure list reordering used by the drag & drop bindings. */
export const reorder = <T>(list: T[], from: number, to: number): T[] => {
  if (from === to || from < 0 || to < 0 || from >= list.length || to >= list.length) {
    return [...list];
  }
  const next = [...list];
  const [moved] = next.splice(from, 1);
  if (moved === undefined) {
    return [...list];
  }
  next.splice(to, 0, moved);
  return next;
};
